import React, { useState, useEffect } from "react";
import './sass/main.scss';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { TokenContextProvider } from "./context-helpers/TokenProvider";
import { InteractionType } from "@azure/msal-browser";
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import { loginRequest } from "./authConfig";
import { Box, createTheme, ThemeProvider } from '@mui/material';
import Roles from "./pages/roles";
import Role from "./pages/role";
import RoleControlMap from "./pages/rolecontrolmap";
import Users from "./pages/users";
import User from "./pages/user";
import Controls from "./pages/controls";
import Control from "./pages/control";
import { FxButton } from "./components/fx";
import Dashboard from "./pages/dashboard";

function App({ msalInstance }: any) {
  const authRequest = {
    ...loginRequest
  };

  const theme = createTheme({
    typography: {
      fontFamily: [
        '"Source Sans 3"', 'sans-serif'
      ].join(',')
    },
  });

  const backToLogin = () => {
    msalInstance.logoutRedirect();
  }

  function errorcomponent({ error }: any) {
    let corIdx: any = error.errorMessage.indexOf("Correlation");
    let message: any = error.errorMessage.substring(0, corIdx);
    return <>
      <Box></Box>
      <Box sx={{ textAlign: "center", mt: 3, color: "red", fontSize: "15px" }}>
        {message}<br></br>
        <FxButton className="m-top-4" label="Back to login" variant="outlined" style={{ padding: '0' }} size="small" onClick={backToLogin} />
      </Box>
    </>;
  }

  const routes: any = [
    { path: "/dashboard", component: Dashboard },
    { path: "/roles", component: Roles },
    { path: "/role/:_id", component: Role },
    { path: "/rolecontrolmap/:role/:_id", component: RoleControlMap },
    { path: "/users", component: Users },
    { path: "/user/:_id", component: User },
    { path: "/controls", component: Controls },
    { path: "/control/:_id", component: Control }
  ]

  return (
    <Router basename="web/">
      <MsalProvider instance={msalInstance}>
        <TokenContextProvider msalInstance={msalInstance}>
          <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={authRequest}
            errorComponent={errorcomponent}
          >
            <ThemeProvider theme={theme}>
              <Header />
              {/* <Route exact={true} path="/" component={ClientList} /> */}
              {routes.map((item: any) => (
                <Route path={item.path} component={item.component} />
              ))}
              <ToastContainer />
              <Footer />
            </ThemeProvider>
          </MsalAuthenticationTemplate>
        </TokenContextProvider>
      </MsalProvider>
    </Router>
  );
}

export default App;
